import api from 'apis/config/api-service';

interface Country {
  id?: string | number;
  [key: string]: any;
}

interface CountryParams {
  [key: string]: any;
}

export default {
  getCountries: (params?: CountryParams) => api.get('countries', { ...params }),
  getCountryById: (id: string | number, params?: CountryParams) => api.get(`countries/${id}`, { ...params }),
  addOrUpdateCountry: (data: Country) =>
    data.id ? api.patch(`countries/${data.id}`, data) : api.post('countries', data),
};
